module.exports = __webpack_public_path__ + "static/Vasudha-Asher.b9a744e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mentImg/Vasudha-Asher.jpg
// module id = 929
// module chunks = 146520050992020